import React from "react";
import Button from 'react-bootstrap/Button';
import {authFetch,handleResponse} from './utils'
import Form from 'react-bootstrap/Form';
import { baseURL } from "./utils";
class AddNewItemComponent extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			taskName: props.initialText?props.initialText:'',
			adding: false,
			followUp:false
		}
		this.addNewItem = this.addNewItem.bind(this);
		this.keyPressed = this.keyPressed.bind(this);
		this.followup = this.followup.bind(this);
		this.handleChange = this.handleChange.bind(this);
	}
	handleChange(event) {
		this.setState({ taskName: event.target.value });
		if (this.props.onChange !== undefined) {
			this.props.onChange(event.target.value);
		}
	}
	keyPressed(event) {
		if (event.key === "Enter") {
			this.addNewItem()
		}

	}
	followup() {
		this.setState({followUp:true, taskName: this.props.parentTaskName },this.addNewItem);
	}
	addNewItem() {
		var textData = this.state.taskName;
		if (textData.trim().length === 0)
			return;
		this.setState({ adding: true })
		var reqBody = {

			name: textData,
			project: this.props.project?.name,
			area: this.props.area

	}
	if(this.props.showFollowUp ==='true' && this.state.followUp){
		reqBody.effort=this.props.effort
		reqBody.priority=this.props.priority
		if(this.props.categories)
			reqBody.categories=this.props.categories
		reqBody.originalTaskId=this.props.parentTaskId
	}

		authFetch(baseURL+'/v1/task/add', {
			method: 'POST',
			body: JSON.stringify(reqBody)
		}).then(res => handleResponse(res))
			.then(
				(result) => {
					if(this.props.showToast){
						this.props.showToast('"' + textData + '" added');
					}
					this.setState({ taskName: '',adding: false })
					this.props.onItemAdded();
				});


		if (this.props.onChange !== undefined) {
			this.props.onChange('');
		}
	}
	render() {
		// the top-bar instance doubles as search (onChange feeds the task filter); modal instances don't
		var isSearchable = this.props.onChange !== undefined;
		var placeholder = isSearchable ? "Add a task… or type to search" : "Task name";
		var icon = isSearchable && this.state.taskName.length >= 3 ? "bi-search" : "bi-plus-circle-dotted";
		return <div className="add-task-bar">
			<i className={"bi " + icon + " add-task-icon"}></i>
			<Form.Control placeholder={placeholder} value={this.state.taskName} onChange={this.handleChange} onKeyPress={this.keyPressed} autoComplete="off" type="text" />
			{ this.props.showFollowUp==='true' && this.state.taskName.length===0 ? <Button variant="outline-secondary" size="sm" className="rounded-pill flex-shrink-0" type="button" onClick={(e) => this.followup(this.props.text, e)}>Follow up</Button> : null }
			{ this.state.taskName.trim().length > 0 &&
			<Button className="add-task-btn" type="button" aria-label="Add task" title="Add task (or press Enter)" disabled={this.state.adding} onClick={(e) => this.addNewItem(this.props.text, e)}>
				{this.state.adding ? <span className="spinner-border spinner-border-sm" role="status"></span> : <i className="bi bi-plus-lg"></i>}
			</Button>}
		</div>
	}
}
export default AddNewItemComponent;
